var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgContributionStep2 = function SvgContributionStep2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "contribution-step-2_svg__\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 40 40",
    style: {
      enableBackground: "new 0 0 40 40"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".contribution-step-2_svg__st2{fill:#172d72}")), /*#__PURE__*/React.createElement("g", {
    id: "contribution-step-2_svg__\\u7EC4_5629",
    transform: "translate(-1072.96 -245.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-2_svg__\\u8DEF\\u5F84_15832",
    d: "M1089 273.9v-4h-4c0 2.2-1.8 4-4 4s-4-1.8-4-4h-4v16h16v-4c2.2 0 4-1.8 4-4s-1.8-4-4-4z",
    style: {
      fill: "#be1d32"
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-2_svg__\\u8DEF\\u5F84_15833",
    d: "M1097 257.9v4h4c0-2.2 1.8-4 4-4s4 1.8 4 4h4v-16h-16v4c-2.2 0-4 1.8-4 4s1.8 4 4 4z",
    style: {
      fill: "#e8eaf1"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "contribution-step-2_svg__\\u7EC4_5629-2",
    transform: "translate(1072.96 245.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-2_svg__\\u8DEF\\u5F84_15834",
    className: "contribution-step-2_svg__st2",
    d: "M4 16H0V0h12v4H4v12z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "contribution-step-2_svg__\\u7EC4_5630",
    transform: "translate(1100.96 269.9)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "contribution-step-2_svg__\\u8DEF\\u5F84_15835",
    className: "contribution-step-2_svg__st2",
    d: "M12 16H0v-4h8V0h4v16z"
  })))));
};
export default SvgContributionStep2;